export default __webpack_public_path__ + "static/media/grubby-5.753667cb.jpg";